class HeroBackgroundVideo {
    constructor() {
        Object.defineProperty(this, "videoBg", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "videoWrp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "videoBgImg", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "videoBgElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.videoWrp = document.querySelector('.block-video-hero');
        this.videoBg = document.querySelector('.block-video-hero__video-bg');
        this.videoBgImg = document.querySelector('.block-main-hero__thumbnail img');
        this.videoBgElement = this.videoBg?.querySelector('#m3u8-background');
    }
    init() {
        this.setSize();
        if (this.videoBgImg && !this.videoBgImg.complete) {
            this.videoBgImg.addEventListener('load', () => {
                this.initVideo();
            });
        }
        else {
            this.initVideo();
        }
    }
    setSize() {
        if (window.innerWidth < 700) {
            this.videoWrp?.setAttribute('style', 'height: ' + this.videoWrp.offsetHeight + 'px !important');
        }
        else {
            this.videoWrp?.removeAttribute('style');
        }
    }
    initVideo() {
        if (!this.videoBgElement)
            return;
        const player = jwplayer(this.videoBgElement).setup({
            playlist: [
                {
                    file: this.videoBgElement.dataset.src ?? '',
                    sources: [],
                    title: '',
                },
            ],
            mute: true,
            repeat: true,
            stretching: 'fill',
        });
        player.setControls(false);
        player.on('firstFrame', function () {
            const elements = document.querySelectorAll('.block-main-hero__thumbnail, .block-main-hero__headline');
            for (const element of elements) {
                element.classList.add('fade');
            }
        });
    }
}
export default new HeroBackgroundVideo();
